import { Link, Outlet } from "react-router-dom"
import { useAppDispatch, useAppSelector } from "../../store/store"
import { Copyright, Disc, Menu } from "lucide-react"
import { useEffect, useState } from "react"
import { getPlayerData } from "../../services/players.services"
import { toast } from "react-toastify"
import { setPlayer } from "../../store/features/playerSlice"
import Content from "../../components/Content"
import Loader from "../../components/Loader"

const Template = () => {
    const [menuOpen, setMenuOpen] = useState<boolean>(false)
    const token = useAppSelector(state => state.token)
    const player = useAppSelector(state => state.player)

    const [loading, setLoading] = useState(true)
    const dispatch = useAppDispatch()

    useEffect(() => {
        if (token) {
            getPlayerData({ token: token || '' })
                .then((res) => {
                    dispatch(setPlayer(res.data.payload.player))
                })
                .catch(() => toast.error("Ha ocurrido un error"))
                .finally(() => setLoading(false))
            return
        }

        setLoading(false)
    }, [token, dispatch])

    if (loading) return (
        <Content className="flex justify-center">
            <Loader />
        </Content>
    )

    return (
        <main className="flex flex-col min-h-screen">
            <div className="flex flex-col md:flex-row gap-5 md:items-center md:justify-between bg-[#459cff] p-5 md:py-5 md:px-32">
                <div className="flex md:items-center justify-between md:justify-start">
                    <Link to="/">
                        <div className="flex flex-col items-start gap-0 relative">
                            {/* <img className="w-[74px] md:w-[130px] md:h-[120px] -mb-[65px] -ml-[15px] rotate-12 z-10" src="/hat_vacations.png" alt="hat" /> */}
                            {/* <img className="absolute md:w-[80px] md:h-[30px] top-5 z-10" src="/lentes_sol.png" alt="hat" /> */}
                            <p className="absolute -right-8 -top-5 text-xl z-10 drop-shadow-[0_1.2px_5px_#f9de7a]">🌞</p>
                            <img style={{ filter: "drop-shadow(2px 0 0 black)" }} className="absolute w-[40px] h-[40px] -left-4 -bottom-2 md:w-[50px] md:h-[50px] md:-left-6 md:-bottom-2 z-10" src="/vaso.png" alt="hat" />


                            <img className="w-[50px] h-[50px] md:w-[70px] md:h-[70px] rounded-full border-2 bg-[#f9de7a] border-black shadow-md" src="/logo_haxstats.png" alt="logo" />
                        </div>
                    </Link>
                    <button className="block text-white md:hidden" onClick={() => setMenuOpen(!menuOpen)}><Menu /></button>
                </div>
                <div className={`md:flex flex-col md:flex-row items-center gap-7 flex ${!menuOpen && "hidden"}`}>
                    <Link className="text-white text-lg font-semibold" to="/">Inicio</Link>
                    <Link className="text-white text-lg font-semibold" to="/ranking/season">Ranking</Link>
                    <Link className="text-white text-lg font-semibold" to="/awards">Premios</Link>
                    <Link className="text-white text-lg font-semibold flex items-center gap-2" to="/records">
                        <Disc size={15} />
                        Recs
                    </Link>
                    {(token && player.admin) && <Link className="text-white text-lg font-semibold" to="/admins">Admins</Link>}
                    <a className="text-white text-lg font-semibold" href="https://discord.gg/aAxFJaDAYe" target="_blank" rel="noreferrer">Discord</a>

                    <div className="h-[45px] border-r border-white hidden md:hidden"></div>
                    {token && <Link className="bg-white px-2 py-1 rounded text-zinc-700 font-semibold" to="/create-team">Crear Equipo</Link>}
                    {!token ?
                        <Link className="bg-white px-2 py-1 rounded text-zinc-700 font-semibold" to="/login">Acceder</Link>
                        :
                        <Link className="bg-white px-2 py-1 rounded text-zinc-700 font-semibold" to={`/p/${player.name}`}>Perfil</Link>
                    }
                </div>
            </div>

            <Outlet />

            <Content>
                <div className="flex gap-2 items-center">
                    <Copyright size={15} />
                    <p className="text-zinc-700">2024 HaxStats</p>
                </div>
            </Content>
        </main>
    )
}

export default Template